export default {
	functional: true,
	name: 'CoinTag',
	props: {
		text: {
			type: String,
			require: true,
		},
	},
	render(h, context) {
		return h(
			'span',
			{
				class: 'global-coin-tag-box',
			},
			[
				h('img', {
					class: 'tag-icon',
					domProps: {
						src: require('@/assets/images/welfare/coin.png'),
					},
				}),
				h(
					'span',
					{
						class: 'tag-num',
					},
					context.props.text
				),
			]
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/CoinTag.js